import { camelToKebabCase } from '../utils/camel-to-kebab-case';

export interface AriaObject {
	[property: string]: string;
}

export const processAriaObject = (ariaObj: AriaObject | string, componentName: string, ariaPropertyName: string) => {
	if (!ariaObj) return {};

	if (typeof ariaObj === 'string') {
		// Convert single quotes to double quotes for each of use in HTML
		if (ariaObj.indexOf('"') === -1) {
			ariaObj = ariaObj.replace(/'/g, '"');
		}

		try {
			ariaObj = JSON.parse(ariaObj);
		} catch (error) {
			console.error(`${componentName}: could not parse '${ariaPropertyName}' property value '${ariaObj}'`, error);
			return {};
		}
	}

	return Object.fromEntries(
		Object.entries(ariaObj).map(([property, value]) => {
			const processedName = `aria-${camelToKebabCase(property)}`;
			return [processedName, value];
		}),
	);
};
